import { render } from "./List_images.vue?vue&type=template&id=fb8ef634&scoped=true"
import script from "./List_images.vue?vue&type=script&lang=js"
export * from "./List_images.vue?vue&type=script&lang=js"

import "./List_images.vue?vue&type=style&index=0&id=fb8ef634&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8ef634"]])

export default __exports__